import Program1Img from '1_shared/assets/images/programs/program-1@1x.png';
import Program4Img from '1_shared/assets/images/programs/program-4@1x.png';
import Program5Img from '1_shared/assets/images/programs/program-5@1x.png';
import Program6Img from '1_shared/assets/images/programs/program-6.webp';

export const slidesConfig = [
  {
    id: 'program-1',
    url: 'https://groups.dotherapy.ru/focus-positive',
    src: Program4Img,
    tags: ['онлайн', 'группа'],
    programTitle: 'Фокус на позитив. Группы дерефлексии',
  },
  {
    id: 'program-2',
    url: 'https://groups.dotherapy.ru/svoboda-vybora',
    src: Program6Img,
    tags: ['онлайн', 'группа'],
    programTitle: 'Свобода выбора. Группы дерефлексии',
  },
  {
    id: 'program-3',
    url: 'https://groups.dotherapy.ru/groupanalysis',
    src: Program5Img,
    tags: ['онлайн', 'группа', '2 года'],
    programTitle: 'Групп-анализ',
  },
  {
    id: 'program-4',
    url: 'https://groups.dotherapy.ru/art',
    src: Program1Img,
    tags: ['онлайн', 'группа', '2 года'],
    programTitle: 'Иммерсивные учебные сессии по арт-терапии',
  },
];
